
import LayoutContainer from '@/components/layout/Container'
import ProjectView from '~/components/project/ProjectView'
import {mapGetters, mapState, mapActions} from 'vuex'

export default {
    name: 'ProjectViewPage',
    head() {
        if (this.application) {
            const meta = [
                {
                    hid: 'og:url',
                    name: 'og:url',
                    content: `https://cofi.ru/project/${this.application.slug}`
                }
            ];
            const head = { meta };
            if (this.application?.seo?.title) {
                head.title = this.application.seo.title;
                meta.push(
                    {
                        hid: 'og:title',
                        name: 'og:title',
                        content: this.application?.seo?.title
                    }
                )
            }
            if (this.application?.seo?.description) {
                meta.push(
                    {
                        hid: 'description',
                        name: 'description',
                        content: this.application?.seo?.description
                    },
                    {
                        hid: 'og:description',
                        name: 'og:description',
                        content: this.application?.seo?.description
                    }
                );
            }
            if (this.application?.seo?.keywords) {
                meta.push(
                    {
                        hid: 'keywords',
                        name: 'keywords',
                        content: this.application?.seo?.keywords
                    }
                );
            }
            return head;
        }
        return {}
    },
    data(){
        return {
            similar: [],
            application : null,
            isAvailableCancelDeal: false,
        }
    },
    async fetch() {
        await this.$axios(`/application/${this.$route.params.slug}`)
            .then(({data}) => {
               this.application = data?.item || null
            })
            .catch(() => {
                this.$nuxt.context.redirect({
                    name: 'vitrina'
                })
            })
        await this.$axios(`/application/${this.application.id}/recommends`)
            .then(({data}) => {
                this.similar = data?.items || []
            })
        if (this.role === 'investor' && this.application.invest && this.application.invest.is_my_invest) {
            await this.$axios.get(`/invest/${this.application.invest.id}/balance`).then(({data}) => {
                this.isAvailableCancelDeal = data?.item?.can_cancel || false
            })
        } else {
            this.isAvailableCancelDeal = null
        }
        
    },
    computed: {
        ...mapGetters('profile', [
            'role'
        ]),
        ...mapState('profile', [
            'currentAccount',
            'isAuthorized'
        ]),
        progressColor() {
            if ((this.application.status === 'fulfilled' || this.application.status === 'finance_round_time' || this.application.status === 'loan_agreement') && this.croudPercentage === 100) {
                return 'green'
            }
            return 'blue'
        },
        interestRate() {
            if (this.application.interest_rate_from === this.application.interest_rate_to) {
                return this.application.interest_rate_from + '%'
            }
            return `${this.application.interest_rate_from} - ${this.application.interest_rate_to}%`
        },
        visibleOisBox() {
            return (this.application.status === 'approved' ||
                this.application.status === 'loan_agreement' ||
                this.application.status === 'finance_round' ||
                this.application.status === 'finance_round_time')
        },
        quill() {
            return (this.$refs.editor && this.$refs.editor.$data.quill) || null;
        },
        isBorrowerIndividual() {
            return this.application.organization.short_opf === 'ИП';
        },
        isPossibleAdd() {
            return !this.application.is_my && this.role && this.role !== 'borrower' && (this.application.status === 'finance_round' || this.application.status === 'approved');
        },
        isFavorite() {
            return this.application.is_favorite
        },
        // isAvailableCancelDeal() {
        //     if (this.application.invest && this.application.invest.created_at) {
        //         return Date.now() - new Date(this.application.invest.created_at) <= 60000 * 60 * 24 * 5;
        //     }
        //     return false;
        // },
        statusText() {
            switch (this.application.status) {
                case 'edit':
                    return 'На редактировании';
                case 'finance_round':
                    return 'Раунд финансирования';
                default:
                    return '';

            }
        },
        coverImage(){
            if (this.application.images && this.application.images.cover_718x535) {
                return this.serverImage(this.application.images.cover_718x535.download_id)
            }
            return IMAGE_PLACEHOLDER
        },
    },
    methods: {
        ...mapActions('favorite', ['setToFavourite', 'removeFromFavourite']),
        handleBack() {
            // 1 - default browser page
            // 2 - application page
            if (window.history.length > 2) {
                return this.$router.back();
            }
            return this.$router.push({ name: 'vitrina' });
        },
        toggleDescription() {
            this.openedDescription = !this.openedDescription
        },
        async toggleFavorite() {
            if (this.role !== 'borrower' && !this.loadingFavorite) {
                this.loadingFavorite = true;
                if (this.isFavorite) {
                    await this.removeFromFavourite(this.application.id);
                    this.$notify({
                        title: 'Заявка удалена из Избранного',
                        type: 'warn',
                    })
                } else {
                    if (this.role == null) {
                        this.$router.push({name: 'register'})
                        return
                    }
                    await this.setToFavourite(this.application.id)
                    this.$notify({
                        title: 'Заявка добавлена в Избранное',
                        type: 'success',
                    })
                }
                this.loadingFavorite = false;
                await this.loadApplication(this.application.id)
                    .then(({ data }) => {
                        this.application = data.item;

                    });
            }
        },
        editApplication() {
            window.open(`/profile/application/${this.application.id}`, '_self');
            // this.$router.push({
            //     path: `/profile/application/${this.application.id}`,
            // })
        },
        cancelDeal () {
            if (!this.application.is_round_ended) {
                this.$modal.show('project-invest-cancel',
                    {
                        application: this.application,
                        callback: this.showInvestCancelModal
                    }
                )
            }
        },
        handleGetFile() {
            if (!this.loadingFile) {
                this.loadingFile = true;
                this.$axios.get(
                    `intellectual-property/application/${this.application.id}/borrower-info-document`,
                    { responseType: 'blob' }
                )
                    .then(({ data }) => {
                        const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
                        const link = document.createElement('a');
                        link.target = '_blank';
                        link.href = url;
                        link.click();
                        // 2 минуты на скачивание, после - удаление
                        setTimeout(() => URL.revokeObjectURL(url), 60000 * 2);
                    })
                    .finally(() => this.loadingFile = false);
            }
        },
        investModal() {
            if(this.application){
                this.$modal.show('project-invest',
                    {
                        application: this.application,
                        callback: this.showInvestConfirmModal
                    }
                )
            }
        },
        async loadApplication(applicationId) {
            return await this.$axios.get(`/application/${applicationId}`);
        },
        showInvestConfirmModal() {
            this.$modal.show('project-invest-confirm', {
                application: this.application,
                callback: this.updateDataApplication
            });
        },
        showInvestCancelModal() {
            this.$modal.show('project-invest-cancel-confirm', {
                application: this.application,
                callback: this.updateDataApplication
            })
        },
        async updateDataApplication() {
            const responseApp = await this.$axios.get(`/application/${this.$route.params.slug}`);
            let responseBalance = null
            if (this.role === 'investor' && responseApp.data.item.invest && responseApp.data.item.invest.is_my_invest) {
                responseBalance = await this.$axios.get(`/invest/${responseApp.data.item.invest.id}/balance`)
            } else {
                responseBalance = null
            }

            this.application = responseApp?.data?.item || null;
            this.isAvailableCancelDeal = responseBalance ? responseBalance?.data?.item?.can_cancel : false;
        }
    },
    components: {
        LayoutContainer,
        ProjectView,
    }
}
